export type UpdateSW = (reloadPage?: boolean) => Promise<void>
export type RegisterUpdate = (handlers: {
  onNeedRefresh: () => void
  onOfflineReady: () => void
}) => UpdateSW
type Listener = (ready: boolean) => void

export class AppUpdater {
  private updateSW: UpdateSW = async () => {}
  private updateReady = false
  private readonly listeners = new Set<Listener>()

  register(registerUpdate: RegisterUpdate): void {
    this.updateSW = registerUpdate({
      onNeedRefresh: () => { this.updateReady = true; this.emit() },
      onOfflineReady: () => undefined
    })
  }

  ready(): boolean { return this.updateReady }
  subscribe(listener: Listener): () => void { this.listeners.add(listener); return () => this.listeners.delete(listener) }

  async apply(): Promise<void> {
    if (!this.updateReady) return
    sessionStorage.setItem('cht-update-applied', '1')
    try {
      await this.updateSW(true)
    } catch (error) {
      sessionStorage.removeItem('cht-update-applied')
      throw error
    }
  }

  consumeApplied(): boolean {
    const applied = sessionStorage.getItem('cht-update-applied') === '1'
    if (applied) sessionStorage.removeItem('cht-update-applied')
    return applied
  }

  private emit(): void { for (const listener of this.listeners) listener(this.updateReady) }
}

export const appUpdater = new AppUpdater()
